// components/TooltipWrapper.tsx
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipWrapper = ({
  tooltip,
  children,
  placement = "top",
  showTooltip = true,
}) => {
  if (!showTooltip) return <>{children}</>;

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip>{tooltip}</Tooltip>}
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
